export default __webpack_public_path__ + "assets/models/af9ce115c8e3d5aedf990bf730396503.glb";